import AddIcon from "@mui/icons-material/Add";
import AndroidOutlinedIcon from "@mui/icons-material/AndroidOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import DevicesOutlinedIcon from "@mui/icons-material/DevicesOutlined";
import EditIcon from "@mui/icons-material/Edit";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import PhoneIphoneOutlinedIcon from "@mui/icons-material/PhoneIphoneOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import RestartAltOutlinedIcon from "@mui/icons-material/RestartAltOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import UnfoldMoreOutlinedIcon from "@mui/icons-material/UnfoldMoreOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const ICON_REGISTRY = {
  add: AddIcon,
  android: AndroidOutlinedIcon,
  arrowBack: ArrowBackIcon,
  arrowBackIos: ArrowBackIosIcon,
  arrowDownward: ArrowDownwardIcon,
  arrowUpward: ArrowUpwardIcon,
  article: ArticleOutlinedIcon,
  barChart: BarChartOutlinedIcon,
  calendarToday: CalendarTodayOutlinedIcon,
  check: CheckOutlinedIcon,
  chevronLeft: ChevronLeftIcon,
  chevronRight: ChevronRightIcon,
  close: CloseIcon,
  cloudUpload: CloudUploadOutlinedIcon,
  confirmationNumber: ConfirmationNumberOutlinedIcon,
  contentCopy: ContentCopyOutlinedIcon,
  dateRange: DateRangeOutlinedIcon,
  delete: DeleteIcon,
  devices: DevicesOutlinedIcon,
  edit: EditIcon,
  editOutlined: EditOutlinedIcon,
  expandLess: ExpandLessIcon,
  expandMore: ExpandMoreIcon,
  fiberManualRecord: FiberManualRecordIcon,
  filterList: FilterListOutlinedIcon,
  home: HomeOutlinedIcon,
  info: InfoOutlinedIcon,
  insertDriveFile: InsertDriveFileOutlinedIcon,
  inventory: Inventory2OutlinedIcon,
  language: LanguageOutlinedIcon,
  localOffer: LocalOfferOutlinedIcon,
  lock: LockOutlinedIcon,
  logout: LogoutOutlinedIcon,
  menu: MenuOutlinedIcon,
  phone: PhoneOutlinedIcon,
  phoneIphone: PhoneIphoneOutlinedIcon,
  refresh: RefreshOutlinedIcon,
  restartAlt: RestartAltOutlinedIcon,
  search: SearchOutlinedIcon,
  unfoldMore: UnfoldMoreOutlinedIcon,
  visibility: VisibilityOutlinedIcon,
  visibilityOff: VisibilityOffOutlinedIcon,
};

export const getIconComponent = (iconName) => ICON_REGISTRY[iconName] ?? null;

export default ICON_REGISTRY;
